import type {IAttributes, IAugmentedJQuery, IParseService, IScope} from 'angular';

/**
 * @ngdoc directive
 * @name kpOnScroll
 * @module portaro.directives
 *
 * @restrict A
 * @element ANY
 *
 * @param {expression} kpOnScroll Expression evaluated if `scroll` event is fired. In `$event` variable is original event.
 *
 * @example
 * ```
 * <example name="kpOnScrollExample" module="kpOnScrollExample">
 *     <file name="index.html">
 *         <main kp-on-scroll="message = 'scrolled! - top: ' + $event.target.scrollTop + '\n' + message">
 *             <div class="too-long"></div>
 *         </main>
 *         <textarea cols="80" rows="30" ng-model="message"></textarea>
 *     </file>
 *     <file name="style.css">
 *         main {
 *             height: 100px;
 *             width: 100px;
 *             overflow: auto;
 *         }
 *
 *         .too-long {
 *             height: 500px;
 *             width: 80px;
 *         }
 *     </file>
 *     <file name="script.js">
 *         angular.module('kpOnScrollExample', ['portaro.directives']);
 *     </file>
 * </example>
 * ```
 */
export default class KpOnScrollDirective {
    public static directiveName = 'kpOnScroll';

    public restrict = 'A';

    /*@ngInject*/
    constructor(private $parse: IParseService) {
    }

    public link($scope: IScope, $element: IAugmentedJQuery, $attrs: IAttributes) {

        const handler = function(event) {
            if ($attrs[KpOnScrollDirective.directiveName]) {
                $scope.$apply(() => this.$parse($attrs[KpOnScrollDirective.directiveName])($scope, {$event: event}));
            }
        }.bind(this);

        $element.on('scroll', handler);

        $scope.$on('$destroy', () => {
            $element.off('scroll', handler);
        });
    }
}
